import { render, staticRenderFns } from "./earningPointsPopup.vue?vue&type=template&id=720349d6&scoped=true&"
import script from "./earningPointsPopup.vue?vue&type=script&lang=js&"
export * from "./earningPointsPopup.vue?vue&type=script&lang=js&"
import style0 from "./earningPointsPopup.vue?vue&type=style&index=0&id=720349d6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "720349d6",
  null
  
)

export default component.exports